import React, { Component } from 'react';
import { connect } from 'react-redux';

import currencyJSON from '../../../../assets/json/currencyConfig.json';

import classes from './PaypalOptions.scss';

import * as paymentActions from '../../../../store/actions/index';

class PaypalOptions extends Component {

    handleOptionChange = (changeEvent) => {
        this.props.onSetPaypalOption(changeEvent.target.value);
    }

    render() {
        return (
            <div>
                <ul className={classes.List}>
                    {
                        this.props.currencies.currencies.map(currency => {
                            return <li key={currency.code} className={`${classes.ListItem} u-flex justify-content-between align-items-center`}>
                                <label className={`${classes.ListItemInner} u-flex justify-content-between align-items-center u-width100Percent u-relative pl-5 u-cursorPointer u-fontSize16 u-noUserSelect`}>
                                    <input 
                                        className={`u-absolute u-cursorPointer u-transparent`}
                                        type='radio' 
                                        value={currency.code} 
                                        checked={this.props.selectedOption ? this.props.selectedOption.code === currency.code : false} 
                                        onChange={this.handleOptionChange}/>
                                    <span className={classes.Checkmark}></span>
                                    <p className={`${classes.ListText} ml-5 u-textColorDark `}><span style={{color: this.props.selectedOption ? this.props.selectedOption.code === 'INR' ? '#3e72f7' : '#666' : '#666', opacity: this.props.selectedOption ? this.props.selectedOption.code === 'INR' ? '1' : '.5' : '.5'}} className={`mr-3 u-fontSize16 u-textColorNormal u-opacity50 u-fontWeightMedium`}>{currencyJSON[currency.code]}</span>{currency.name}</p>
                                    <div className={classes.ListPrice}>{this.props.amountDetails.totalAmount / currency.rate}</div>
                                </label>
                            </li>
                        })
                    }
                </ul>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        currencies: state.payments.currencies,
        amountDetails: state.payments.amountDetails,
        selectedOption: state.payments.selectedPaypalOption
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetPaypalOption: (val) => dispatch(paymentActions.setPaypalOption(val))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaypalOptions);


// WEBPACK FOOTER //
// ./src/components/Payment/Paypal/PaypalOptions/PaypalOptions.js